import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from './rootReducer'
import refreshTokenMiddleware from './auth/refreshTokenMiddleware'
import thunk from 'redux-thunk'
import { IntlActions } from 'react-redux-multilingual'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const persistConfig = {
   key: 'root',
   storage,
   whitelist: ['payment']
}
const persistedReducer = persistReducer(persistConfig, rootReducer)

export default () => {
   let store = createStore(persistedReducer, composeEnhancers(applyMiddleware(thunk)))
   store.dispatch(IntlActions.setLocale('fa'))
   let persistor = persistStore(store)
   return { store, persistor }
}